module.exports = __webpack_public_path__ + "static/provenance-book-a192cb9984ecdd1acae28a24cdda8f74.jpg";